import nextId from "react-id-generator";
import { v4 as uuidv4 } from 'uuid';
// Lesson 1.2
export const MTCText1 = [

    {
        eng: "Robert Fisk - famous british journalist ",
        rus: "Роберт Фиск - известный британский журналист ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "and correspondent of Independent newspaper ",
        rus: "и корреспондент газеты Индепендент ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "he is living in Beirut ",
        rus: "он проживает в Бейруте ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "capital of Lebanon ",
        rus: "столице Ливана ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "more than 25 years.",
        rus: "более двадцати пяти лет.",
        id: nextId('MTCText1-id-'),
        turned: true
    }
];

export const MTCText2 = [

    {
        eng: "Barack Obama - first in history afro-american ",
        rus: "Барак Обама - первый в истории афро-американец ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "who became the president of America ",
        rus: "который стал президентом Америки ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "he served 2 terms, 4 years ",
        rus: "он служил 2 срока по 4 года ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "overall 8 years ",
        rus: "всего 8 лет ",
        id: nextId('MTCText1-id-'),
        turned: true
    }
];

export const MTCText3 = [

    {
        eng: "my name is Alex ",
        rus: "меня зовут Алекс ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "I am from New York ",
        rus: "я из Нью Йорка ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "I drive yellow taxi ",
        rus: "я вожу жёлтое такси ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "I earn 80 dollars per day ",
        rus: "Я зарабатываю 80 долларов в день ",
        id: nextId('MTCText1-id-'),
        turned: true
    }
];

export const MTCText4 = [

    {
        eng: "Maya Plisetskaya - soviet ballet dancer",
        rus: "Майа Плисецкая - советская балерина",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "She worked in the theatre Bolshoi ",
        rus: "Она работала в театре Большой ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "she was born in Moscow ",
        rus: "она родилась в Москве ",
        id: nextId('MTCText1-id-'),
        turned: true
    },
    {
        eng: "and died in Germany ",
        rus: "и умерла в Германии ",
        id: nextId('MTCText1-id-'),
        turned: true
    }
];

// Lesson 1.3
export const MTCText5 = [

    {
        eng: "My name is Hasan Shash  ",
        rus: "Меня зовут Хасан Шаш ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "I am former professional footballer ",
        rus: "я бывший профессиональный футболист ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "In my country ",
        rus: "В моей стране ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "people like football very much ",
        rus: "люди очень сильно любят футбол ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "our fans just crazy ",
        rus: "наши фаны просто бешеные ",
        id: nextId('MTCText2-id-'),
        turned: true
    }
];

export const MTCText6 = [

    {
        eng: "Her name is Angela Merkel  ",
        rus: "Её зовут Ангела Меркель ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "She has been Chancellor since 2005 ",
        rus: "Она является канцлером с 2005 года ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "She is a representative of the party ",
        rus: "Она представитель партии ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "By profession she is physicist chemist ",
        rus: "По профессии она физико-химик ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "But she chose politics ",
        rus: "Но она выбрала политику ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "Because she wants ",
        rus: "Так как она хочет ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "Do contribution ",
        rus: "Делать вклад ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "In development of the country ",
        rus: "В развитие страны ",
        id: nextId('MTCText2-id-'),
        turned: true
    }
];

export const MTCText7 = [

    {
        eng: "His name is Mozart ",
        rus: "Его зовут Моцарт ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "He is a great austrian composer, conductor ",
        rus: "Он великий австроийский композитор, дирижёр ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "He is a representative of Viennese classical music music ",
        rus: "Он представитель венской, классической школы музыки ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "He is an author of more than 600 pieces of music ",
        rus: "Он автор более 600 музыкальных произведений ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "our fans just crazy ",
        rus: "наши фаны просто безумные ",
        id: nextId('MTCText2-id-'),
        turned: true
    }
];

export const MTCText8 = [

    {
        eng: "Your name is Boris Ivanov ",
        rus: "Тебя зовут Борис Иванов ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "You will work as CAI agent under cover in Russia ",
        rus: "Ты будешь работать агентом ЦРУ под прикрытием в России ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "You need to get data ",
        rus: "Тебе нужно узнать данные ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "About secret weapon and its location ",
        rus: "О секретном оружии и его локацию ",
        id: nextId('MTCText2-id-'),
        turned: true
    }
];

export const MTCText9 = [
    {
        eng: "Our names are Vladimir and Vitali Klitchko ",
        rus: "Нас зовут Владимир и Виталий Кличко ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "We are former professional boxers ",
        rus: "Мы бывшие профессиональные боксёры ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "in a heavy weight ",
        rus: "в тяжёлом весе ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "over 91 kilograms ",
        rus: "свыше 91 килограмм ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "after career endings in boxing ",
        rus: "после завершения карьеры в боксе ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "Vitalii became a politician ",
        rus: "Виталий стал политиком ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "Now he is a mayor of the Kiev city ",
        rus: "сейчас он мэр города Киев ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "and I founded own company ",
        rus: "а я основал свою компанию ",
        id: nextId('MTCText2-id-'),
        turned: true
    }
];

// Lesson 2.1 Работать
export const MTCText10 = [
    {
        eng: "I work as a banker in the bank",
        rus: "Я работаю банкиром в банке",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "Do you work as an actor in the theatre?",
        rus: "Ты работаешь в театре актёром?",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "He works as a doctor in the hospital",
        rus: "Он работает доктором в больнице ",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "She works as a secretary in the office",
        rus: "Она работает секретарём в офисе",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "You work as a deputy in the parliament",
        rus: "Вы работаете депутатом в парламенте",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "We work as teachers at the school",
        rus: "Мы работаем учителями в школе",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "They work as professors at the university",
        rus: "Они работают профессорами в университете",
        id: nextId('MTCText2-id-'),
        turned: true
    }
];

// Lesson 2.1 Завтракать Обедать Ужинать Unit 4
export const MTCText11 = [
    {
        eng: "I have breakfast at home, have lunch at the cafe, and have dinner at the bar",
        rus: "Я завтракаю дома, обедаю в кафе и ужинаю в баре",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "You have breakfast at work, have lunch at the food court, and have dinner at the cafe",
        rus: "Ты завтракаешь на работе, обедаешь в фудкорте и ужинаешь в кафе",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "He has breakfast at the pizzeria, has lunch at the restaurant, and has dinner at home",
        rus: "Он завтракает в пицерии, обедает в ресторане и ужинает дома",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "You have breakfast at work, have lunch at the cafe shop, and have dinner at the restaurant",
        rus: "Вы завтракаете на работе, обедаете в кафешопе и ужинаете в ресторане",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "We have breakfast at the restaurant, have lunch at the cafeteria, and have dinner at the pizzeria",
        rus: "Мы завтракаем в ресторане, обедаем в кафетерии и ужинаем в пицерии",
        id: nextId('MTCText2-id-'),
        turned: true
    },
    {
        eng: "They have breakfast at the cafe shop, have lunch at the canteen, and have dinner at the bar",
        rus: "Они завтракают в кафешопе, обедают в столовой и ужинают в баре",
        id: nextId('MTCText2-id-'),
        turned: true
    }
];

// Lesson 2.2 Unit 5
export const MTCText12 = [
    {
        eng: "My granddaughter is a manager",
        rus: "Моя внучка менеджер",
        id: uuidv4(),
        turned: true
    }, {
        eng: "She manages a successful company from the list of Forbes",
        rus: "Она управляет успешной компанией из списка Форбс",
        id: uuidv4(),
        turned: true
    }, {
        eng: "In her company work 200 people from different countries",
        rus: "В её компании работают 200 человек из разных стран",
        id: uuidv4(),
        turned: true
    }, {
        eng: "This year because of COVID-19 results of the company got worse",
        rus: "В этом году, из-за Ковид-19 результаты компании ухудшились",
        id: uuidv4(),
        turned: true
    }, {
        eng: "But I hope, that next year everything will be well",
        rus: "Но я надеюсь, что на следующий год все будет хорошо",
        id: uuidv4(),
        turned: true
    }, {
        eng: "My father is a successful enterpreneur his name is Rashid",
        rus: "Мой папа успешный предприниматель его зовут Рашид",
        id: uuidv4(),
        turned: true
    }, {
        eng: "In his business very taugh competiton",
        rus: "В его бизнесе очень жёсткая конкуренция",
        id: uuidv4(),
        turned: true
    }, {
        eng: "Therefore he works very hard",
        rus: "Поэтому он работает очень усердно",
        id: uuidv4(),
        turned: true
    }, {
        eng: "He goes to work at 7 and comes (home) only at 9 of evening",
        rus: "Он идёт на работу в 7 часов и приходит только в 9 вечера",
        id: uuidv4(),
        turned: true
    }, {
        eng: "He says, that time-management helps him to be competitive",
        rus: "Он говорит, что тайм-менеджмент помогает ему быть конкурентноспособным",
        id: uuidv4(),
        turned: true
    }, {
        eng: "I respect dad very much",
        rus: "Я очень уважаю папу",
        id: uuidv4(),
        turned: true
    }, {
        eng: "My mother does not work, she is a housewife",
        rus: "Моя мама не работает, она домохозяйка",
        id: uuidv4(),
        turned: true
    }, {
        eng: "By the way her name is Lena",
        rus: "Кстати, её зовут Лена",
        id: uuidv4(),
        turned: true
    }, {
        eng: "She is a very clever woman",
        rus: "Она очень умная женщина",
        id: uuidv4(),
        turned: true
    }, {
        eng: "She reads a lot and learn different languages",
        rus: "Она много читает и изучает разные языки",
        id: uuidv4(),
        turned: true
    }, {
        eng: "She likes to learn languages",
        rus: "Она любит изучать языки",
        id: uuidv4(),
        turned: true
    }, {
        eng: "Because this helps her find out about cultures and traditions of different nations",
        rus: "Так как это помогает ей узнавать о культурах и традициях разных народов",
        id: uuidv4(),
        turned: true
    }, {
        eng: "For example, recently she found out",
        rus: "Например, недавно она узнала",
        id: uuidv4(),
        turned: true
    }, {
        eng: "Aborigines of Australia have unique musical instruments",
        rus: "Аборигены Австралии имеют уникальные музыкальные инструменты",
        id: uuidv4(),
        turned: true
    }, {
        eng: "Which exist only in their culture",
        rus: "Которые существуют только в их культуре",
        id: uuidv4(),
        turned: true
    }
];

// Custom Jon Lesson 1

// Одеваться
// present tense (perfect)
export const MTCTextCustomJon1dash1 = [
    {
        eng: "I usually  get dressed very long ",
        rus: "Обычно я одеваюсь очень долго ",
        id: nextId('MTCText1-1-id-'),
        turned: true
    },
    {
        eng: "You always dress up very beautifully ",
        rus: "Ты всегда одеваешься очень красиво ",
        id: nextId('MTCText1-1-id-'),
        turned: true
    },
    {
        eng: "Sometimes he dresses (buys clothes) at the market ",
        rus: "Иногда он одвается на базаре ",
        id: nextId('MTCText1-1-id-'),
        turned: true
    },
    {
        eng: "They never get undressed when they goes to sleep ",
        rus: "Они никогда не раздеваются когда идут спать ",
        id: nextId('MTCText1-1-id-'),
        turned: true
    },
    {
        eng: "They get undressed in front of people, but it is not good ",
        rus: "Они раздеваются перед людьми, но это нехорошо ",
        id: nextId('MTCText1-1-id-'),
        turned: true
    },
    {
        eng: "When you get undressed make sure that nobody is around ",
        rus: "Когда вы раздеваетесь, убедитесь что рядом никого нет ",
        id: nextId('MTCText1-1-id-'),
        turned: true
    }
];

// Одеваться
// future tense (imperfect)
export const MTCTextCustomJon1dash2 = [
    {
        eng: "When I am rich I will dress in expensive stores ",
        rus: "Когда я буду богатым, я буду одеваться в дорогих магазинах ",
        id: nextId('MTCText1-2-id-'),
        turned: true
    },
    {
        eng: "If you dress stylishly you will look more presentable ",
        rus: "Если ты будешь одеваться сти'льно, ты будешь выглядеть более презентабельно ",
        id: nextId('MTCText1-2-id-'),
        turned: true
    },
    {
        eng: "She will get dresses while we eat pizza ",
        rus: "Она будет одеваться пока мы будем кушать пиццу ",
        id: nextId('MTCText1-2-id-'),
        turned: true
    },
    {
        eng: "In England you will dress like gentleman ",
        rus: "В Англии вы будете одеваться как джентльмен",
        id: nextId('MTCText1-2-id-'),
        turned: true
    },
    {
        eng: "They will dress in Gucci and Armani when get salary ",
        rus: "Они будут одеваться в Гуччи и Арма'ни когда заработают деньги ",
        id: nextId('MTCText1-2-id-'),
        turned: true
    },
    {
        eng: "We will dress like superstars after we complete the project ",
        rus: "Мы будем одеваться как суперзвезды, после того, как закончим проект ",
        id: nextId('MTCText1-2-id-'),
        turned: true
    }
];

// Одеваться
// future tense (perfect)
export const MTCTextCustomJon1dash3 = [
    {
        eng: "As I said to you, by 4 o'clock I will have already got dressed ",
        rus: "Как я уже тебе сказал, к четырем часам я уже оденусь ",
        id: nextId('MTCText1-3-id-'),
        turned: true
    },
    {
        eng: "You promised, that by the noon you will have got dressed ",
        rus: "Ты обещал, что к обеду ты оденешься ",
        id: nextId('MTCText1-3-id-'),
        turned: true
    },
    {
        eng: "I am sure, that she will get dressed beautifully for this party ",
        rus: "Я уверен, что она оденется красиво для этой вечеринки ",
        id: nextId('MTCText1-3-id-'),
        turned: true
    },
    {
        eng: "If we dress like gangsters, they will arrest us ",
        rus: "Если мы оденемся как гангстеры, они нас арестуют ",
        id: nextId('MTCText1-3-id-'),
        turned: true
    },
    {
        eng: "When you get dressed as needed, she will like you ",
        rus: "Когда вы оденетесь как надо, она полюбит вас ",
        id: nextId('MTCText1-3-id-'),
        turned: true
    },
    {
        eng: "They will get dressed stylishly to attract investors ",
        rus: "Они оденутся стильно, чтобы привлечь инвесторов ",
        id: nextId('MTCText1-3-id-'),
        turned: true
    }
];

// Одеваться
// past tense (imperfect)
export const MTCTextCustomJon1dash4 = [
    {
        eng: "I was getting dressed in my room, when the phone rang ",
        rus: "Я одевался в своей комнате когда телефон позвонил ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "When you were getting dressed, the thief stole your wallet ",
        rus: "Когда ты одевался вор украл твой кошелёк ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "While he was getting dressed, he forgot everything he wanted to say ",
        rus: "В то время как он одевался, он забыл все что хотел сказать ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "While she was getting dressed, children were playing noisily ",
        rus: "В то время как она одевалась дети играли шумно ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "I saw how you (plural) were getting dressed hastily  ",
        rus: "Я видел как вы одевались в спешке ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "In our time we dressed the way simplier ",
        rus: "В наше время мы одевались намного проще ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "In 20th century men in England dressed formally ",
        rus: "В 20-ом веке мужчины в Англии одевались формально ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    }
];

// Одеваться
// past tense (perfect)
export const MTCTextCustomJon1dash5 = [
    {
        eng: "I have already got dressed and waiting for you ",
        rus: "Я уже оделся и жду тебя ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "Have you got dressed yet? ",
        rus: "Ты уже оделся? ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "He got dressed quickly and went to work ",
        rus: "Он быстро оделся и пошёл на работу ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "She got dressed and went to the shop ",
        rus: "Она оделась и пошла в магазин ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "I hope you have already got dressed, bucause we are getting late for the bus  ",
        rus: "Я надеюсь вы уже оделись потому что мы опаздываем на автобус ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "We have just got dressed ",
        rus: "Мы только что оделись ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    },
    {
        eng: "Mother wanted us to dress like Marvel superheroes ",
        rus: "Мама хотела, чтобы мы оделись как супергерои марвела ",
        id: nextId('MTCText1-4-id-'),
        turned: true
    }
];


// Мыться
// present tense (imperfect)
export const MTCTextCustomJon1dash6 = [
    {
        eng: "I wash myself 8 times a month ",
        rus: "Я моюсь восемь раз в месяц ",
        id: nextId('MTCText1-6-id-'),
        turned: true
    },
    {
        eng: "How do you feel yourself when you wash yourself at guest? ",
        rus: "Как ты себя чувствуешь когда моешься в гостях? ",
        id: nextId('MTCText1-6-id-'),
        turned: true
    },
    {
        eng: "He does not wash himself at work because it is dirty there ",
        rus: "Он не моется на работе, потому что там грязно ",
        id: nextId('MTCText1-6-id-'),
        turned: true
    },
    {
        eng: "I do not like that she washes herself so often ",
        rus: "Мне не нравится, что она моется так часто ",
        id: nextId('MTCText1-6-id-'),
        turned: true
    },
    {
        eng: "Do you listen to music when you wash yourself?  ",
        rus: "Вы слушаете музыку когда моетесь? ",
        id: nextId('MTCText1-6-id-'),
        turned: true
    },
    {
        eng: "We do not wash ourselves in sauna, because we have a heart condition ",
        rus: "Мы не моемся в бане, потому что у нас больное сердце ",
        id: nextId('MTCText1-6-id-'),
        turned: true
    },
    {
        eng: "Please wait for them, they are still washing themsleves ",
        rus: "Пожалуйста подожди их, они еще моются ",
        id: nextId('MTCText1-6-id-'),
        turned: true
    }
];

// Мыться
// future tense (imperfect)
export const MTCTextCustomJon1dash7 = [
    {
        eng: "I will be washing myself, please, watch nobody comes in ",
        rus: "Я буду мыться пожалуйста посмотри чтобы никто не зашёл ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Will you be washing yourself in the evening? ",
        rus: "Ты будешь мыться вечером? ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He will be washing himself only if there is hot water in the tap",
        rus: "Он будет мыться только, если есть горячая вода в кране ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Do not occupy the bathroom she will be washing herself ",
        rus: "Не занимай ванную она будет мыться ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When you wash yourself, make sure that there is hot water in the tap ",
        rus: "Когда вы будете мыться убедитесь, что в кране есть горячая вода ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We will be washing ourself only if there is cold water ",
        rus: "Мы будем мыться только если будет холодная вода ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Ask them will they be washing themselves? ",
        rus: "Спроси у них они будут мыться? ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];


// Мыться
// future tense (perfect)
export const MTCTextCustomJon1dash8 = [
    {
        eng: "I will wash myself if it is possible ",
        rus: "Я помоюсь если можно ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "As soon as you wash yourself, let me know, I need to check water ",
        rus: "Как только ты помоешься дай мне знать, мне нужно проверить воду ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He will wash himself and then he will go to the shop to buy some bread",
        rus: "Он помоется а затем пойдет в магазин купить хлеб ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "She decided that she will wash herself at 4, since the bathroom will be occupied ",
        rus: "Она решила что помоется в 4, так как ванная комната будет занята ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When you will have washed youself, please turn the light off ",
        rus: "Когда вы помоетесь, пожалуйста выключите свет ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Let them wash themselves, otherwise they will be angry ",
        rus: "Пусть они помоются, иначе они будут злые ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "They will wash themselves and they will go to bed ",
        rus: "Они помоются и пойдут спать ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Мыться
// past tense (imperfect)
export const MTCTextCustomJon1dash9 = [
    {
        eng: "I was washing myself unhurriedly, thought there is still time ",
        rus: "Я мылся неспеша, думал, что есть еще время ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When you were washing yourself in bathroom, thieves entered the house ",
        rus: "Когда ты мылся в ванной, воры проникли в дом ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We knew that he was washing himself so we didn't call ",
        rus: "Мы знали что он мылся поэтому мы не звонили ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "She was washing herself under the shower, and thought about her problems ",
        rus: "Она мылась под душем, и думала о своих проблемах ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When was the last time you washed? ",
        rus: "Когда вы мылись в последний раз ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We were washing so we didn't hear the knock on the door ",
        rus: "Мы мылись поэтому мы не слышали стук в дверь ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When they washed, they usually used a washcloth, soap and shampoo ",
        rus: "Когда они мылись они обычно использовали мочалка, мыло и шампунь ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Мыться
// past tense (perfect)
export const MTCTextCustomJon1dash10 = [
    {
        eng: "I have already washed you can come in ",
        rus: "Я уже помылся вы можете зайти ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "People are interested, whether you have already washed yourself ",
        rus: "Люди интересуются, ты уже помылся ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He has not yet washed, although in the bathroom for 2 hours ",
        rus: "Он еще не помылся хотя в ванной 2 часа ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I didn't notice that she had already washed ",
        rus: "Я не заметил что она уже помылась ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Sorry to bother you, but have you showered yet? ",
        rus: "Извините за беспокойство, но вы уже помылись? ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We washed 20 minutes ago and immediately went to eat ",
        rus: "Мы помылись 20 минут назад и сразу пошли кушать ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "They washed and immediately went to the concert ",
        rus: "Они помылись и сразу пошли на концерт ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Бриться
// present tense (imperfect)
export const MTCTextCustomJon1dash11 = [
    {
        eng: "I shave every day because my beard grows fast ",
        rus: "Я бреюсь каждый день,потому что моя борода растет быстро ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When you shave do you use an electric shaver? ",
        rus: "Когда ты бреешься ты используешь электробритву? ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He shaves not so often, so his stubble grows back after two days ",
        rus: "Он бреется не так часто, поэтому у него отрастает щетина после двух дней ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Despite the fact that she is a woman, she grows a mustache ",
        rus: "Несмотря на то что она женщина, у неё растут усы ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Do you shave to smooth skin? ",
        rus: "Вы бреетесь до гладкой кожи? ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We don’t shave to look more brutal ",
        rus: "Мы не бреемся, чтобы выглядеть более брутально ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Today's young people don't shave, this is becoming a trend ",
        rus: "Современные молодые люди не бреются, это становится трэндом ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Бриться
// future tense (imperfect)
export const MTCTextCustomJon1dash12 = [
    {
        eng: "Son, free the bathroom, I'll shave ",
        rus: "Сынок освободи ванную я буду бриться ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "You said you'd shave, but instead you bathe ",
        rus: "Ты сказал что будешь бриться, а вместо этого ты купаешься ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Mark won't shave he grows a beard ",
        rus: "Марк не будет бриться он отращивает бороду ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Anna won't shave she has no problem with testerone ",
        rus: "Анна не будет бриться у ней нет проблем с тестестероном ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I'll give you shaving foam if you shave ",
        rus: "Я дам вам пену для бритья если вы будете бриться ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We'll shave to look younger ",
        rus: "Мы будем бриться чтобы выглядеть моложе ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Men will shave less in the future, according to a recent study ",
        rus: "Согласно недавнему исследованию, мужчины будут меньше бриться в будущем ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Побриться
// future tense (perfect)
export const MTCTextCustomJon1dash13 = [
    {
        eng: "I'll have myself shaved by lunchtime, so don't worry ",
        rus: "К обеду я уже побреюсь, так что не волнуйся",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I think by evening you will have shaved, otherwise we will waste a lot of time ",
        rus: "Я думаю к вечеру ты уже побреешься, а то мы потеряем много времени ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He didn't say that he would shave, he just said that he would tidy up the mustache ",
        rus: "Он не сказал что побреется, он просто сказал что приведет в порядок усы ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Sarah said she needed a shave, honestly I was a little shocked ",
        rus: "Сара сказала что ей нужно побриться, честное слово я был немного в шоке ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "A beard suits you so well, if you shave I won't talk to you anymore ",
        rus: "Вам так идёт борода, если вы побреетесь я больше не буду с вами разговаривать ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We will shave and put on a new suit to impress the opposite sex ",
        rus: "Мы побреемся и оденем новый костюм чтобы впечатлить противоположный пол ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "They will shave and then go to guests ",
        rus: "Они побреются а затем пойдут в гости ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Бриться
// Past tense (imperfect)
export const MTCTextCustomJon1dash14 = [
    {
        eng: "I was shaving for about 30 minutes ",
        rus: "Я брился примерно 30 минут",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "While you were shaving, the kettle boiled ",
        rus: "В то время пока ты брился, чайник закипел ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He was shaving and thought about the upcoming meeting ",
        rus: "Он брился и думал о предстоящей встрече ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "She didn’t shave as she was a woman ",
        rus: "Она не брилась так как была женщиной ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When you were shaving, I was cooking dinner and your wife was watching TV. ",
        rus: "Когда вы брились я готовил ужин, а ваша жена смотрела телевизор ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We weren't shaving last night, we were playing football ",
        rus: "Вчера вечером мы не брились, мы играли футбол ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I know for sure that they were shaving, since I heard the sound of an electric shaver ",
        rus: "Я точно знаю что они брились, так как я слышал звук электробритвы ",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Побриться
// Past tense (perfect)
export const MTCTextCustomJon1dash15 = [
    {
        eng: "I shaved and now I can sleep well",
        rus: "Я побрился и теперь могу спать спокойно",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "If you shaved, she would recognize you",
        rus: "Если бы ты побрился, она бы тебя узнала",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He didn't shave because he wants to look like Harden",
        rus: "Он не побрился так как хочет выглядеть как Харден",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "You have already shaved, I urgently need a bathroom",
        rus: "Вы уже побрились, мне срочно нужна ванная",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We finally shaved, after 10 years in the forest",
        rus: "Мы наконец-то побрились, после 10 лет в лесу",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "They did not shave since there was not a blade in the store",
        rus: "Они не побрились, так как в магазине не было лезвий",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Краситься
// Present tense (imperfect)
export const MTCTextCustomJon1dash16 = [
    {
        eng: "I put on make up every day to look beautiful",
        rus: "Я крашусь каждый день чтобы выглядеть красиво",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Despite the fact that you put on make up you do not become prettier",
        rus: "Несмотря на то что ты красишься ты не становишься красивее",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He does wear make up although he is a man. Something is wrong with him",
        rus: "Он красится хотя он мужчина. Что-то с ним не так",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When she puts on make up it is very difficult to recognize her",
        rus: "Когда она красится очень трудно её узнать",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When you put on make up what products do you use?",
        rus: "Когда вы краситесь, какую продукцию вы используете?",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We don't wear makeup because we want to look natural",
        rus: "Мы не красимся потому что мы хотим выглядеть естественно",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Why do they put on make up if it doesn't help them anyway?",
        rus: "Для чего они красятся если все равно это им не помогает?",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Краситься
// Future tense (imperfect)
export const MTCTextCustomJon1dash17 = [
    {
        eng: "I will put on makeup when I want and where I want",
        rus: "Я буду краситься когда захочу и где захочу",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When you put on makeup, please don't keep your mouth open",
        rus: "Когда ты будешь краситься пожалуйста не держи рот открытым",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He will be wearing makeup for a new show in which he will play a woman",
        rus: "Он будет краситься для нового шоу, в котором будет играть женщину",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Tomorrow she will get up early, because in the morning she will be putting on makeup",
        rus: "Завтра она встанет пораньше, так как утром она будет краситься",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Why will you put on makeup if you know that paint causes allergies?",
        rus: "Зачем вы будете краситься, если знаете что краска вызывает аллергию?",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We will not put on makeup, because we are beautiful enough without cosmetics",
        rus: "Мы не будем краситься, так как и без косметики мы достаточно красивые",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "If I knew that they would put on makeup, I would buy cosmetics",
        rus: "Если бы я знал что они будут краситься, я бы купил косметику",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Накраситься
// Future tense (perfect)
export const MTCTextCustomJon1dash18 = [
    {
        eng: "Give me the cosmetics, I'll put on makeup and go",
        rus: "Подай мне косметику я накрашусь и пойду",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I didn't think you'd put on your makeup so vulgarly",
        rus: "Я не думал что ты накрасишься так вульгарно",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Sarah will put on makeup to seduce her colleague",
        rus: "Сара накрасится для того чтобы соблазнить своего коллегу",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Maria will put on makeup for her grandmother, because she wants to see her in different style",
        rus: "Мария накрасится для своей бабушке, потому что она хочет видеть её в другом стиле",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "As soon as you put on your makeup, call me it is very urgent",
        rus: "Как только вы накраситесь, позвоните мне это очень срочно",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We'll put on makeup, or maybe the party will be canceled, and then what will we do",
        rus: "Мы накрасимся, а может быть вечеринку отменят, и что мы потом будем делать",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Schoolgirls will put on makeup and take the stage in five minutes",
        rus: "Школьницы накрасятся и через пять минут выйдут на сцену",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Краситься
// Past tense (imperfect)
export const MTCTextCustomJon1dash19 = [
    {
        eng: "I was putting on makeup in the basement of our studio and it was hot there",
        rus: "Я красилась в подвале нашей студии и там было жарко",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Honey, when you were putting on makeup, I forgot to turn off the gas-stove and all the food burned",
        rus: "Дорогая, когда ты красилась, я забыл выключить газ-плиту и вся еда сгорела",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When I entered his room, he was putting on makeup, and then abruptly hid his makeup",
        rus: "Когда я вошел в его комнату он красился, а потом резко спрятал косметику",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Maria used to wear makeup every day, but now her skin does not perceive cosmetics",
        rus: "Мария раньше красилась каждый день, но сейчас её кожа не воспринимает косметику",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Why did you wear makeup so bright, it annoyed me",
        rus: "Почему вы красились так ярко, меня это раздражало",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We wore makeup because it was fashionable, but now we understand that it was stupid",
        rus: "Мы красились потому что это было модно, но сейчас понимаем, что это было глупо",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Before, the secretaries used to put makeup less provocative and looked decent",
        rus: "Раньше секретарши красились менее вызывающе, и выглядели достойно",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Накраситься
// Past tense (perfect)
export const MTCTextCustomJon1dash20 = [
    {
        eng: "I put on makeup in advance and waited for the guests, but unfortunately they did not come",
        rus: "Я накрасилась заранее и ждала гостей, но к сожалению они не пришли",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I know you put on makeup to piss me off",
        rus: "Я же знаю, что ты накрасилась, чтобы разозлить меня",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He had to put on makeup as he wanted to please them",
        rus: "Ему пришлось накраситься, так как он хотел угодить им",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Why did you put on makeup, did you not know that we would not go to the wedding?",
        rus: "Зачем вы накрасились, вы что не знали, что мы не пойдем на свадьбу?",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We put on makeup like princesses and they rejected us",
        rus: "Мы накрасились как принцессы, а они нас отвергли",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "They put on makeup and are ready to go on stage, I hope everything goes according to plan",
        rus: "Они накрасились и уже готовы выйти на сцену, надеюсь все пойдет по плану",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Собираться/Собраться
// Present tense (imperfect)
export const MTCTextCustomJon1dash21 = [
    {
        eng: "I'm getting ready for a trip, so don't bother me to pack my suitcases",
        rus: "Я собираюсь в дорогу, так что не мешай мне упаковывать чемоданы",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Are you going to tell him the truth at last?",
        rus: "Ты собираешься сказать ему правду наконец?",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "He's going to buy a car to work as a taxi driver",
        rus: "Он собирается купить машину, чтобы работать таксистом",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "She is not going to appeal despite the unfair outcome",
        rus: "Она не собирается подавать апелляцию, несмотря на несправедливый результат",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "It seems to me that you are going to tell me something, am I right?",
        rus: "Мне кажется, что вы собираетесь, что-то мне сказать, я права?",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We are going to buy a house in New Orleans as my husband will work there",
        rus: "Мы собираемся купить дом в Новом Орлеане, так как мой муж будет там работать",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Tom and Jessica are getting married in September while the weather is warm",
        rus: "Том и Джессика собираются пожениться в Сентябре, пока погода теплая",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Собираться/Собраться
// Future tense (imperfect)
export const MTCTextCustomJon1dash22 = [
    {
        eng: "I'll be packing for the road, make sure all my things are in my bag",
        rus: "Я буду собираться в дорогу, убедись, что все мои вещи в сумке",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "When you are going to pack for England, please call John in advance to meet you.",
        rus: "Когда ты будешь собираться в Англию, пожалуйста, позвони заранее Джону, чтобы он тебя встретил",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Alex will be getting ready for school and will be in a hurry, so he may forget some things",
        rus: "Алекс будет собираться в школу и спешить, поэтому он может забыть некоторые вещи",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Nastya will be getting ready for the road tonight, she said she will take two heavy bags",
        rus: "Настя будет собираться в дорогу сегодня вечером, она сказала,что возьмет две тяжелые сумки",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I heard that you will be meeting at John's house, I advise you to cancel the meeting due to coronavirus restrictions",
        rus: "Я слышал, что вы будете собираться у Джона дома, советую отменить встречу из-за короновирусных ограничений",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We will meet at Tom's, as he has a big, luxurious house by the sea",
        rus: "Мы будем собираться у Тома, так как у него большой, раскошный дом на берегу моря",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Harry and Megan will be getting ready for Europe, now they are preparing a large list of documents",
        rus: "Гарри и Меган будут собираться в Европу, сейчас они готовят большой список документов",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Собираться/Собраться
// Future tense (perfect)
export const MTCTextCustomJon1dash23 = [
    {
        eng: "By this time, I'll be ready and will be waiting for you",
        rus: "К этому времени я уже соберусь и буду ждать тебя",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I hope you will compose yourself and correct the mistake",
        rus: "Я надеюсь ты соберешься и исправишь ошибку",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I believe that he will collect his thoughts and come to the right decision",
        rus: "Я верю что он соберется с мыслями и придет к правильному решению",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Anna will get ready by noon and immediately order a taxi to the airport",
        rus: "Анна соберется к обеду и сразу закажет такси до аэропорта",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I heard that you will meet at the building by 9 o'clock for a demonstration",
        rus: "Я слышал что вы соберетесь у здания к 9 часам для демонстрации",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "We decided that we will meet at John's house and celebrate the successful completion of the project",
        rus: "Мы решили что мы соберемся у Джона дома и отметим успешное окончание проекта",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "I know that the demonstrators will gather in the square and shout slogans",
        rus: "Я знаю что демонстранты соберутся на площади и будут кричать лозунги",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Собираться/Собраться
// Past tense (imperfect)
export const MTCTextCustomJon1dash24 = [
    {
        eng: "I was going to visit my mom, but then I remembered about meeting with the dentist",
        rus: "К этому времени я уже соберусь и буду ждать тебяЯ собирался посететь маму, но потом вспомнил о встрече с дантистом",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "As far as I know you were going to buy a premium car this year",
        rus: "Насколько я знаю ты собирался купить машину премиум класса в этом году",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "John was getting ready for the trip, and had already packed his suitcase, then he remembered that he had not put the comb",
        rus: "Джон собирался в дорогу, и уже упаковал чемодан, потом вспомнил, что не положил расческу",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "She was going to tell him everything, but because of excitement she could not find the right words",
        rus: "Она собиралась все ему рассказть, но из-за волнения не могла подобрать нужные слова",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "Last year, we were going to conquer Mont Blanc, but due to a serious injury, we remained in the city",
        rus: "В прошлом году, мы собирались покорить Монблан, но ввиду тяжелой травмы остались в городе",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "According to media reports, you gathered at the casino for three weeks in a row, despite the strict restrictions",
        rus: "По информации СМИ, вы собирались в казино три недели подряд, несмотря на строгие ограничения",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "They were going to attack the police from behind, but one awkward movement ruined their plans",
        rus: "Они собирались атаковать неожиданно полицейских сзади, но одно неловкое движение разрушило из планы",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];

// Собираться/Собраться
// Past tense (perfect)
export const MTCTextCustomJon1dash25 = [
    {
        eng: "I got ready to go to the gym, but realised my membership had expired",
        rus: " Я собрался в спортзал, но осознал, что срок моего членства истек",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "You got ready for the 20 hour journey to Aberdeen through Istanbul and London",
        rus: "Ты собрался к 20-часовой поездке в Абердин через Стамбул и Лондон",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "Jon was about to buy a toy for his daughter, but realised, that he did not take money",
        rus: "Джон собрался купить игрушку для своей дочки, но осознал, что забыл взять деньги",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "So she packed up and moved out, and when she went to collect it, it wasn't there",
        rus: "Поэтому она собралась и съехала с квартиры, а когда пошла забрать его, его там не было оказалось",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "Today we are gathered to celebrate the life of Charles Van Der Elst",
        rus: "Сегодня мы собрались чтобы отпраздновать жизнь Чарльза Ван Дер Элста",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "I was afraid you were going to abandon me, like so many others",
        rus: "Я боялся, что вы собрались отвернуться от меня, как и многие другие",
        id: nextId('MTCText1-7-id-'),
        turned: true
    },
    {
        eng: "They gathered in the lobby to say goodbye to you",
        rus: "Они собрались в холле и хотят попрощаться с вами",
        id: nextId('MTCText1-7-id-'),
        turned: true
    }
];


//Present tense садиться (imperfect)
export const MTCTextCustomJon1dash26 = [
    {
        eng: "I am sitting down I realise,that the woman next to me is an old jealous girlfriend",
        rus: "Я сажусь и осознаю, что женщина возле меня, старая, завистливая девушка",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "You are sitting  down on the wrong side of the church",
        rus: "Ты садишься на неправильную сторону церкви",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "He is sitting down in the road. Why would he do that?",
        rus: "Он садится на дорогу, зачем ему это делать?",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "She is sitting down on the wrong bike. That does not belong to her",
        rus: "Она садится на ошибочный велосипед. Он не принадлежит ей",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "We are sitting down together",
        rus: "Мы садимся вместе",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "You sit down when you feel tired or if you feel dizzy",
        rus: "Вы садитесь когда чувствуете усталость или головокружение",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "They are sitting down together after a long days skiing",
        rus: "Они садятся вместе после долгих дней катания на лыжах",
        id: nextId('MTCText1-8-id-'),
        turned: true
    }
];

//Future tense садиться (imperfect)
export const MTCTextCustomJon1dash27 = [
    {
        eng: "I will be sitting down everytime I hear the music stop",
        rus: "Я буду садиться каждый раз, когда буду слышать, что музыка остановилась",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "You will be sitting down when we pass the low bridges",
        rus: "Ты будешь садиться когда мы будем проходить по низким мостам",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "He will be sitting down as the train pulls away",
        rus: "Он будет садиться в то время как поезд будет отъезжать",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "She will be sitting down during the long speech because she is pregnant",
        rus: "Она будет садиться во время долгого выступления, потому что она беременная",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "We will be sitting down as the whistle blows",
        rus: "Мы будем садиться когда будет свистеть свисток",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "You will be sitting down during the service because it last 2 hours",
        rus: "Вы будете садиться во время обслуживания, потому что оно длится 2 часа",
        id: nextId('MTCText1-8-id-'),
        turned: true
    },
    {
        eng: "They will be sitting down as the carousel speedsup",
        rus: "Они будут садиться по мере того, как карусель будет ускоряться",
        id: nextId('MTCText1-8-id-'),
        turned: true
    }
];

// Садиться (Future perfect)
export const MTCTextCustomJon1dash28 = [
    {
        eng: "I will sit down when I have finished the argument",
        rus: "Я сяду когда закончу спор",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "You will sitdown after the singer has finished her first song",
        rus: "Ты сядешь после того, как певица закончит её первую песню",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "He will sit down after the toasts",
        rus: "Он сядет после нескольких тостов",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "She will sit down before starts to paint",
        rus: "Она сядет перед тем как начнет красить",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "We will sit down to plan next years trip",
        rus: "Мы сядем чтобы распланировать поездку на следующий год",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "You will sit down and fasten your setbelts before I start the car",
        rus: "Вы сядете и пристегнёте ваши ремни безопасности до того как я заведу машину",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "They will sit down in the big armchairs to watch the three hour movie",
        rus: "Они сядут на большое кресло чтобы посмотреть трёх часовой фильм",
        id: uuidv4(),
        turned: true
    }
];

// Садиться (Past perfect)
export const MTCTextCustomJon1dash29 = [
    {
        eng: "I was sitting down when I heard them celebrating",
        rus: "Я садился когда слышал как они праздновали",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "You were sitting down when she made the mistake of complaining about the food",
        rus: "Ты садился когда она сделала ошибку пожаловшись на еду",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "He was sitting down when he heard his trousers rip",
        rus: "Он садился когда услышал как его штаны порвались",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "She was sitting down thinking about her revenge",
        rus: "Она садилась, думая о мести",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "We were sitting down together when the bench broke",
        rus: "Мы садились вместе когда скамейка сломалась",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "You were sitting down  and talking so you missed the joke",
        rus: "Вы садились и разговаривали поэтому вы не поняли шутку",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "They were just sitting down when the car jumped forward",
        rus: "Они садились когда машина прыгнула вперёд",
        id: uuidv4(),
        turned: true
    }
];

// Сесть (Past perfect)
export const MTCTextCustomJon1dash30 = [
    {
        eng: "I sat down in frustration  because of the endless arguments",
        rus: "Я сел в отчаянии из-за бесконечных споров",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "You sat down exhausted and immediately fell asleep",
        rus: "Ты сел сильно уставшим и сразу заснул",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "He sat down because he wanted to kiss his wife",
        rus: "Он сел, потому что хотел поцеловать жену",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "She sat down next to her daughter who was hugging the dog",
        rus: "Она села рядом с дочерью, которая обнимала собаку",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "We sat down around the round table and started laughing and drinking together",
        rus: "Мы сели за круглый стол и начали вместе смеяться и пить",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "You can not believe you sat down before the guests. I hope they are not offended",
        rus: "Вы не можете поверить, что сели раньше гостей. Надеюсь они не обиделись",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "They sat down without hesitation because they wanted to hear the story",
        rus: "Они сели без раздумий, потому что хотели услышать историю",
        id: uuidv4(),
        turned: true
    }
];

//Careful
export const MTCTextCustomJon1dash31 = [
    {
        eng: "If you are running look forwards not backwards or you will fall",
        rus: "Если ты бежишь, смотри вперёд не назад или ты упадешь",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Look where you are going",
        rus: "Смотри куда ты идёшь",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "If you are under the table be careful when you stand up or you will hit your head",
        rus: "Если ты под столом, будь осторожна когда встаёшь, или ты ударишь голову",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Do not crawl on the floor its dirty",
        rus: "Не ползай по полу он грязный",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Behave or you will knock the glass over",
        rus: "Остановись или ты уронишь стакан",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Do not play with your dinner. It is not a toy. Please eat properly",
        rus: "Не играй с едой (ужином). Это не игрушка. Пожалуйста, ешь нормально",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Do not run over the floor it has just been cleaned. The lady will have to clean again if you make it dirty",
        rus: "Не бегай по полу, его помыли. Тёте придётся мыть его снова если ты его замараешь",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Do not throw the toys you may hit someone",
        rus: "Не бросай игрушки ты можешь попасть в кого-нибудь",
        id: uuidv4(),
        turned: true
    }
];

//Games
export const MTCTextCustomJon1dash32 = [
    {
        eng: "Where is Mia hiding?",
        rus: "Где Мия прячется?",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Papa monster is hungry he needs brains for dinner",
        rus: "Папа-монстр голодный ему нужны мозги на ужин",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "I think I can smell brains. Maybe the brains of a small girl. Tasty",
        rus: "Я думаю, я чую запах мозгов. Может быть мозги маленькой девочки. Вкусно",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Do you feel dizzy after the carousel?",
        rus: "Ты чувствуешь головокружение после карусели?",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Who is following me?",
        rus: "Кто преследует меня?",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "I can hear someone breathing",
        rus: "Я чуствую чьё-то дыхание",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Mia lost this game and Mia will lose the next game",
        rus: "Мия проиграла эту игру и Мия проиграет следующую игру",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "What game are you playing are you winning?",
        rus: "Какую игру ты играешь, ты выигрываешь?",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Should I push you on the swing?",
        rus: "Мне качать тебя?",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Do not swing too high and hold on with both hands",
        rus: "Не качайся так высоко и держись двумя руками",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Ready to go super high on the swing? Maybe you will fly from the seat? Get ready to fly",
        rus: "Готова раскачаться супер высоко? Может быть ты улетишь из качели. Приготовься летать",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Do you like the magnetic blocks I gave you. What did you build?",
        rus: "Тебе понравились магнитные блоки, которые я дал тебе. Что ты построила?",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "To win the game you need four counter in a row. Either Up, down or sideways",
        rus: "Чтобы выиграть игру тебе нужно четыре фишки в ряд. Либо вверх, вниз или по бокам",
        id: uuidv4(),
        turned: true
    }
];

// Plants versus Zombies
export const MTCTextCustomJon1dash33 = [
    {
        eng: "Zombie team will make a plan to fight and win",
        rus: "Команда зомби сделает план чтобы сражаться и выиграть",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Plants team will make a plan to fight and win",
        rus: "Команда растений сделает план чтобы сражаться и выиграть",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Zombie Team is the strongest",
        rus: "Команда зомби самая сильная",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Plant team has 5 players against 3 zombies but zombies are stronger",
        rus: "У команды растений пять игроков против трёх зомби, но команда зомби сильнее",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Zombies run the fastest so they will win",
        rus: "Зомби бегают самое быстро, поэтому они выиграют",
        id: uuidv4(),
        turned: true
    }
];

// Pazzle
export const MTCTextCustomJon1dash34 = [
    {
        eng: "Did you have flu and a fever",
        rus: "У тебя был грипп и простуда?",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "That piece is upside down. Turn it around",
        rus: "Пазл вверх ногами. Поверни",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "That piece is in the wrong place",
        rus: "Пазл в неправильном месте",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Where do you think that piece fits? Can you see the same colour on the puzzle?",
        rus: "Как ты думаешь куда подходит этот пазл? Видишь одинаковые цвета на пазле?",
        id: uuidv4(),
        turned: true
    }
];


// Painting
export const MTCTextCustomJon1dash35 = [
    {
        eng: "Draw a straight line between the dots. Use a ruler",
        rus: "Рисуй прямую линию между точками. Используй линейку",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Draw a straight line between there are there",
        rus: "Рисуй прямую линию между там и там",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Draw a curved line between the shapes",
        rus: "Рисуй кривую линию между фигурами",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Don’t scribble you will ruin the picture",
        rus: "Не рисуй каракули ты испортишь рисунок",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "You need more water with the paint, the paint is too thick",
        rus: "Тебе нужно добавить больше воды в краску, краска слишком густая",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "That is too much glue it will stick to everything",
        rus: "Слишком много клея, он будет прилипать ко всему",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "What would you like to draw next? Can you draw a painting for Papa?",
        rus: "Что бы ты хотела нарисовать следующим? Можешь нарисовать для папы?",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Hold the paint brush properly it will make a better picture",
        rus: "Держи кисточку правильно, так ты будешь рисовать лучше",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "What colour do you get if you mix blue and yellow?",
        rus: "Какой цвет ты получишь если смешаешь синий и жёлтый?",
        id: uuidv4(),
        turned: true
    }
];

// Вставать (present tense imperfect)
export const MTCTextCustomJon1dash36 = [
    {
        eng: "If I get up early I feel cheerful",
        rus: "Если я встаю рано я чувствую себя бодро",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "If you get out of bed quickly, you may feel dizzy.",
        rus: "Если ты встаёшь с кровати быстро, ты можешь чувствовать головокружение",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "If he strikes a pose, just ignore him",
        rus: "Если он встаёт в позу, просто игнорируй его",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Every Monday she gets up on the wrong foot",
        rus: "Каждый понедельник она встаёт не с той ноги",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "If you get up at 7 in the morning, you usually come an hour earlier",
        rus: "Если вы встаёте в 7 часов утра вы как правило приходите на час раньше",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "When we get up in the morning, we usually feel sleepy.",
        rus: "Когда мы встаём утром, мы обычно испытываем сонливость",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "They get up late on Friday because they don't have to go to work.",
        rus: "В пятницу они встают позднее, так как им не нужно идти на работу",
        id: uuidv4(),
        turned: true
    }
];

// Вставать (present tense imperfect)
export const MTCTextCustomJon1dash37 = [
    {
        eng: "In New York I will get up early in the morning and go jogging in manhattan (area)",
        rus: "В Нью Йорке я буду вставать рано утром и делать пробежку в районе Манхэттана",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Tomorrow when you will get up, put on slippers, which will be under the bed",
        rus: "Завтра когда ты будешь вставать, одень тапочки, которые будут под кроватью",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "What for will he get up after the punch in this episode?",
        rus: "Для  чего он будет вставать после удара в этом эпизоде?",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "She won't get up too early for this job",
        rus: "Она не будет вставать слишком рано для этой работы",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "You will get up at night to drink your medicine",
        rus: "Вы будете вставать ночью чтобы выпить лекарство",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "We will get up and go to school together to be safer",
        rus: "Мы будем вставать и вместе идти в школу,чтобы было безопасней",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "They will be constantly getting up and sit down, so they will need more comfortable and practical clothing",
        rus: "Они будут постоянно вставать и садиться, поэтому им нужна будет более удобная и практичная одежда",
        id: uuidv4(),
        turned: true
    }
];

// Встать (future tense perfect)
export const MTCTextCustomJon1dash38 = [
    {
        eng: "I'll just get up and leave now because you're deceiving me",
        rus: "Я сейчас просто встану и уйду, потому что ты меня обманываешь",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "You go to bed earlier, you get up earlier, he says cheerfully",
        rus: "Раньше ляжешь, раньше встанешь, ― весело говорит он",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "I will tear apart anyone who gets in my way!",
        rus: "Я разорву любого, кто встанет на моем пути!",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "If Masha gets up, there will be a fight, she just lies there and cannot do anything",
        rus: "Если Маша встанет, будет драка, она просто лежит и ничего не может сделать",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Let's you stand in line for a subsidy, and within a year you will receive it",
        rus: "Давайте вы встанете в очередь на субсидию, и в течение года вы ее получите",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "Together we will rise and walk to freedom",
        rus: "Мы вместе встанем и пойдем к свободе",
        id: uuidv4(),
        turned: true
    },
    {
        eng: "It was clear that sooner or later they would get up",
        rus: "Было понятно, что рано или поздно они встанут",
        id: uuidv4(),
        turned: true
    }
];